import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ReactQuill from 'react-quill'
import {observer, inject} from 'mobx-react'
import ClickOutHandler from 'react-onclickout'
// eslint-disable-next-line
import theme from 'react-quill/dist/quill.snow.css'
import '../components/css/RichTextField.css'

class RichTextField extends Component {

    constructor(params) {
        super(params)
        this.onClickOut = this.onClickOut.bind(this)
        this.state = {
            characterCount: 0,
            showStatus: false,
            showSaved: false,
            showSaving: false,
            richTextState: null,
        }
    }

    componentWillReceiveProps(nextProps){
        this.setState({
            richTextState: nextProps.description,
        })
    }

    onClickOut(e) {
        this.setState({
            showStatus: false,
        })
    }

    wordCount(value, delta, source, editor){
        if(this.state.richTextState !== value){ // only store changes if the content has changed
            this.props.onChange(value)
            this.setState({
                showStatus: true,
                richTextState: value,
                })
            setTimeout(() => {
            this.setState({
                showSaved: true,
                })
            },500)            
        }
    }

    statusSymbol(){
        const {stores} = this.props
        const {store} = stores
        if (!store.online) {
            return <span className='richTextReconnect'><strong>Reconnecting... If you reload, changes will be lost!</strong></span>
        } else if (store.savingRichField){
            return <div> <span className='glyphicon glyphicon-refresh Spinner' style={{fontSize:15+'px', color: 'green'}}></span><span className='richTextSaving'> Saving...</span></div>
        } else if (this.state.showSaved){
            return <span className='richTextSaved'>Saved!</span>
        } else {
            return null
        }
    }

    render(){
        return (
            <div>
                <ClickOutHandler onClickOut={this.onClickOut}>
                <ReactQuill 
                    value={this.state.richTextState}
                    placeholder={this.props.placeholder}
                    onChange={this.wordCount.bind(this)}
                    theme='snow'
                />
                <div>
                    {this.state.showStatus === true &&
                        <div className='richTextStatusSymbol'>
                        {this.statusSymbol()}
                        </div>
                    }
                </div>
                </ClickOutHandler>
            </div>
            
        )
    }
}
RichTextField.propTypes = {
    description: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
}

export default inject("stores")(observer(RichTextField))



// WEBPACK FOOTER //
// ./src/components/RichTextField.js